import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import pdca_m_soshiki_divisionQueries from '../../queries/pdca_m_soshiki_division.queries';
import { FETCH_M_SOSHIKI_DIVISIONS } from '../../queries/pdca_m_soshiki_division.queries.type';

export interface Saishutsu {
    saishutsu_name: string;
    totalAmount: number;
}
type SaishutsusByYear = Record<number, Saishutsu[]>;
export interface Sainyu {
    sainyu_name: string;
    totalAmount: number;
}

type SainyusByYear = Record<number, Sainyu[]>;

/**
 * トップページContainerのカスタムフック
 * @returns
 */
export const useToppageContainer = () => {
    // HACK: ↓コンテナー以外でuseParamsから取得しないこと。関数の引数で渡してください。CrossTownのReadme.md Component 実装（Container/Presentational Pattern）例 を参照
    const { lgcode, jigyoYear }: { lgcode: string; jigyoYear: string } = useParams();

    // HACK: ↓データの取得はフック内で無くコンテナーで行うこと。CrossTownのReadme.md Component 実装（Container/Presentational Pattern）例 を参照
    // マスターデータ取得
    const { data } = useQuery<FETCH_M_SOSHIKI_DIVISIONS>(pdca_m_soshiki_divisionQueries.FETCH_M_SOSHIKI_DIVISIONS, {
        variables: { lgcode: lgcode, createdYear: Number(jigyoYear) - 1 },
        fetchPolicy: 'cache-first',
        onError: (error) => {
            console.error(error.message);
        },
    });

    // R7支出
    const saishutsus: SaishutsusByYear = {
        2026: [
            { saishutsu_name: '議会費', totalAmount: 105157 },
            { saishutsu_name: '総務費', totalAmount: 2266197 },
            { saishutsu_name: '民生費', totalAmount: 3658426 },
            { saishutsu_name: '衛生費', totalAmount: 818785 },
            { saishutsu_name: '農林水産業費', totalAmount: 1005806 },
            { saishutsu_name: '商工費', totalAmount: 2178165 },
            { saishutsu_name: '土木費', totalAmount: 1305496 },
            { saishutsu_name: '消防費', totalAmount: 652899 },
            { saishutsu_name: '教育費', totalAmount: 1311046 },
            { saishutsu_name: '災害復旧費', totalAmount: 1047 },
            { saishutsu_name: '公債費', totalAmount: 1530168 },
            { saishutsu_name: '予備費', totalAmount: 19808 },
        ],
        2025: [
            {
                saishutsu_name: '議会費',
                totalAmount: 96553,
            },
            {
                saishutsu_name: '総務費',
                totalAmount: 2870907,
            },
            {
                saishutsu_name: '民生費',
                totalAmount: 3464100,
            },
            {
                saishutsu_name: '衛生費',
                totalAmount: 641780,
            },
            {
                saishutsu_name: '農林水産業費',
                totalAmount: 1233523,
            },
            {
                saishutsu_name: '商工費',
                totalAmount: 392717,
            },
            {
                saishutsu_name: '土木費',
                totalAmount: 1101430,
            },
            {
                saishutsu_name: '消防費',
                totalAmount: 363512,
            },
            {
                saishutsu_name: '教育費',
                totalAmount: 1471686,
            },
            {
                saishutsu_name: '災害復旧費',
                totalAmount: 1045,
            },
            {
                saishutsu_name: '公債費',
                totalAmount: 1506867,
            },
            {
                saishutsu_name: '予備費',
                totalAmount: 19880,
            },
        ],
        2024: [
            {
                saishutsu_name: '議会費',
                totalAmount: 104705,
            },
            {
                saishutsu_name: '総務費',
                totalAmount: 2860441,
            },
            {
                saishutsu_name: '民生費',
                totalAmount: 3387741,
            },
            {
                saishutsu_name: '衛生費',
                totalAmount: 565048,
            },
            {
                saishutsu_name: '農林水産業費',
                totalAmount: 918070,
            },
            {
                saishutsu_name: '商工費',
                totalAmount: 148083,
            },
            {
                saishutsu_name: '土木費',
                totalAmount: 1174943,
            },
            {
                saishutsu_name: '消防費',
                totalAmount: 316686,
            },
            {
                saishutsu_name: '教育費',
                totalAmount: 1749234,
            },
            {
                saishutsu_name: '災害復旧費',
                totalAmount: 49910,
            },
            {
                saishutsu_name: '公債費',
                totalAmount: 1377505,
            },
            {
                saishutsu_name: '諸支出金',
                totalAmount: 0,
            },
        ],
    };

    // R7収入
    const sainyus: SainyusByYear = {
        2026: [
            { sainyu_name: '町税', totalAmount: 1772690 },
            { sainyu_name: '地方譲与税', totalAmount: 119112 },
            { sainyu_name: '利子割交付金', totalAmount: 3722 },
            { sainyu_name: '配当割交付金', totalAmount: 14896 },
            { sainyu_name: '株式等譲渡所得割交付金', totalAmount: 19381 },
            { sainyu_name: '法人事業税交付金', totalAmount: 29747 },
            { sainyu_name: '地方消費税交付金', totalAmount: 494301 },
            { sainyu_name: 'ゴルフ場利用税交付金', totalAmount: 1504 },
            { sainyu_name: '環境性能割交付金', totalAmount: 972 },
            { sainyu_name: '地方特例交付金', totalAmount: 29830 },
            { sainyu_name: '地方交付税', totalAmount: 4790000 },
            { sainyu_name: '交通安全対策特別交付金', totalAmount: 1000 },
            { sainyu_name: '分担金及び負担金', totalAmount: 35516 },
            { sainyu_name: '使用料及び手数料', totalAmount: 159104 },
            { sainyu_name: '国庫支出金', totalAmount: 1608308 },
            { sainyu_name: '県支出金', totalAmount: 1105791 },
            { sainyu_name: '財産収入', totalAmount: 24574 },
            { sainyu_name: '寄附金', totalAmount: 409312 },
            { sainyu_name: '繰入金', totalAmount: 1159410 },
            { sainyu_name: '繰越金', totalAmount: 100000 },
            { sainyu_name: '諸収入', totalAmount: 184430 },
            { sainyu_name: '町債', totalAmount: 2789400 },
        ],
        2025: [
            {
                sainyu_name: '町税',
                totalAmount: 1762584,
            },
            {
                sainyu_name: '地方譲与税',
                totalAmount: 120556,
            },
            {
                sainyu_name: '利子割交付金',
                totalAmount: 1310,
            },
            {
                sainyu_name: '配当割交付金',
                totalAmount: 9960,
            },
            {
                sainyu_name: '株式等譲渡所得割交付金',
                totalAmount: 11745,
            },
            {
                sainyu_name: '法人事業税交付金',
                totalAmount: 29800,
            },
            {
                sainyu_name: '地方消費税交付金',
                totalAmount: 429778,
            },
            {
                sainyu_name: 'ゴルフ場利用税交付金',
                totalAmount: 1838,
            },
            {
                sainyu_name: '環境性能割交付金',
                totalAmount: 15472,
            },
            {
                sainyu_name: '地方特例交付金',
                totalAmount: 11259,
            },
            {
                sainyu_name: '地方交付税',
                totalAmount: 4580000,
            },
            {
                sainyu_name: '交通安全対策特別交付金',
                totalAmount: 791,
            },
            {
                sainyu_name: '分担金及び負担金',
                totalAmount: 38016,
            },
            {
                sainyu_name: '使用料及び手数料',
                totalAmount: 156037,
            },
            {
                sainyu_name: '国庫支出金',
                totalAmount: 1544285,
            },
            {
                sainyu_name: '県支出金',
                totalAmount: 1109304,
            },
            {
                sainyu_name: '財産収入',
                totalAmount: 24967,
            },
            {
                sainyu_name: '寄付金',
                totalAmount: 407811,
            },
            {
                sainyu_name: '繰入金',
                totalAmount: 1018673,
            },
            {
                sainyu_name: '繰越金',

                totalAmount: 100000,
            },
            {
                sainyu_name: '諸収入',

                totalAmount: 324514,
            },
            {
                sainyu_name: '町債',

                totalAmount: 1465300,
            },
        ],
        2024: [
            {
                sainyu_name: '町税',
                totalAmount: 1682884,
            },
            {
                sainyu_name: '地方譲与税',
                totalAmount: 117212,
            },
            {
                sainyu_name: '利子割交付金',
                totalAmount: 948,
            },
            {
                sainyu_name: '配当割交付金',
                totalAmount: 13729,
            },
            {
                sainyu_name: '株式等譲渡所得割交付金',
                totalAmount: 17956,
            },
            {
                sainyu_name: '法人事業税交付金',
                totalAmount: 28247,
            },
            {
                sainyu_name: '地方消費税交付金',
                totalAmount: 414928,
            },
            {
                sainyu_name: 'ゴルフ場利用税交付金',
                totalAmount: 1861,
            },
            {
                sainyu_name: '環境性能割交付金',
                totalAmount: 12892,
            },
            {
                sainyu_name: '地方特例交付金',
                totalAmount: 77052,
            },
            {
                sainyu_name: '地方交付税',
                totalAmount: 4758357,
            },
            {
                sainyu_name: '交通安全対策特別交付金',
                totalAmount: 987,
            },
            {
                sainyu_name: '分担金及び負担金',
                totalAmount: 40480,
            },
            {
                sainyu_name: '使用料及び手数料',
                totalAmount: 156488,
            },
            {
                sainyu_name: '国庫支出金',
                totalAmount: 1684772,
            },
            {
                sainyu_name: '県支出金',
                totalAmount: 1017998,
            },
            {
                sainyu_name: '財産収入',
                totalAmount: 20447,
            },
            {
                sainyu_name: '寄付金',
                totalAmount: 277403,
            },
            {
                sainyu_name: '繰入金',
                totalAmount: 804797,
            },
            {
                sainyu_name: '繰越金',

                totalAmount: 575050,
            },
            {
                sainyu_name: '諸収入',

                totalAmount: 275334,
            },
            {
                sainyu_name: '町債',

                totalAmount: 1274700,
            },
        ],
    };

    return { data, saishutsus: saishutsus[Number(jigyoYear)] || [], sainyus: sainyus[Number(jigyoYear)] || [] };
};
